var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"pension-modal-suggestions-step-success"},[(_vm.suggestion.type)?_c('HelperView',{attrs:{"title":_vm.title,"description":_vm.description,"icon-colors":[_vm.NebraskaColors.statusPositive],"icon":"ic_check","data-testid":"summary"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }